<template>
  <div class="page-content" id="onlineCommunication">
    <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>通知公众号</el-breadcrumb-item>
        <el-breadcrumb-item>在线沟通</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
       <el-button type="primary" @click="newUrl">点击扫描二维码,登录客服在线沟通</el-button>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
          return{

          }
        },
        methods:{
          newUrl() {
            window.open('https://mpkf.weixin.qq.com/','_blank')
          }
        }
    }
</script>

<style lang="scss">
    #onlineCommunication{
      .page {
        padding: 20px;
        margin: 10px 0px 0px 0px;
        background-color: white;
        height: 900px;
        line-height: 600px;
        text-align: center;
      }
    }
</style>
